<script setup lang="ts">
import { isPlatformIs24 } from '@/helpers/Platform/Platform';

export interface Props {
  errorText?: string;
}

withDefaults(defineProps<Props>(), {
  errorText: 'valuationForm.emptyRadioError',
});
</script>

<template>
  <span
    :class="isPlatformIs24() ? $style.errorMessageIs24 : $style.errorMessageHg"
    data-cy="valuationFunnelErrorText"
  >
    {{ $t(errorText) }}
  </span>
</template>

<style scoped lang="scss" module>
@use '@/assets/variables' as *;

.errorMessageHg {
  @include body-3($color-orange-80);
}

.errorMessageIs24 {
  @include body-3($color-red-100);
}
</style>
